import { AppState } from 'types';

export function setDataAction(state: AppState, payload: Partial<AppState>) {
	return {
		...state,
		data: {
			...state.data,
			...payload.data
		}
	};
}
